/**
 * Makes popups shown using the checkbox hack accessible
 */

import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/core/get/get.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/events/trigger/trigger.js";
import "dabbyjs/src/traversal/filter/filter.js";

$(() => {
	const names = []; // remember the names of the radios we have attached the change event trigger to
	const ids = [];

	// labels that indicate they control something
	$("label[for][aria-expanded=true][aria-controls]").each(function () {
		const $this = $(this),
			target = $(this).attr("aria-controls");
		
		// track which items we are attaching to because there may be many labels for one control
		if (!ids.includes(target)) {
			const targetobj = $("#" + target),
				checkbox = $("#" + $this.attr("for")),
				raw = checkbox.get(0);

			// when the attached radiobox is ticked
			checkbox.on("change accessiblity.update", e => {
				const checked = checkbox.prop("checked");
				targetobj.attr("aria-expanded", checked ? "true" : "false").filter(() => checked).attr("tabindex", -1);

				// only focus when the event source is a label
				if (e.target === $this.get(0)) {
					targetobj.trigger("focus");
				}
			});

			// for radio buttons, trigger the change event on all radios when one of them changes
			if (raw.name && raw.type === "radio" && !names.includes(raw.name)) {
				const radios = $("input[type=radio][name='" + raw.name + "']");
				radios.on("change", () => radios.not(targetobj).trigger("accessiblity.update"));
				names.push(raw.name);
			}
			ids.push(target);
		}
	});
});